import SupplierClientPage from "../SupplierClientPage";

const SupplierPage = () => <SupplierClientPage supplierType="CLIENTE" translationPrefix="settings.customer" />;

export default SupplierPage;
